import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Marks an <ng-template ptlHeaderCell="columnKey"> whose content renders that
 * column's header in <ptl-data-table>, in place of the plain `label`. For
 * headers carrying more than a name — a due date, a class average, a count —
 * which a single string cannot lay out or style.
 *
 * The column is exposed as both `$implicit` and `column`, e.g.
 * `<ng-template ptlHeaderCell="score" let-column>`. As with `ptlCell`, columns
 * generated from data share one template via `PtlTableColumn.headerTemplateKey`
 * and read themselves off the context.
 *
 * A sortable column keeps its sort button; the template renders inside it.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- design-system attribute API (ptlHeaderCell), not an app 'og' directive
  selector: 'ng-template[ptlHeaderCell]',
})
export class PtlTableHeaderDirective {
  @Input('ptlHeaderCell') column!: string;

  /*
   * The context column is loose on purpose. A header template exists to show what `PtlTableColumn` does
   * not carry — a due date, a class average — so consumers pass their own extension of it, the way rows
   * are already `Record<string, any>` in the cell directive.
   */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  constructor(public readonly template: TemplateRef<{ $implicit: any; column: any }>) {}
}
